import * as React from 'react'
import mapboxgl, {Popup} from 'mapbox-gl';
import {ZoomControl} from 'react-mapbox-gl'
import {Map, Marker} from "@parsimap/react-mapbox-gl"
import {Announcement} from "@mui/icons-material";

mapboxgl.setRTLTextPlugin(
   'https://cdn.parsimap.ir/third-party/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
   null,
)


function ParsiMap(props) {
  const [zoom, setZoom] = React.useState(null);


  return (
     <Map ref={props?.mapRef} lat={props?.latToMap || props?.coordinates[0]?.pointX || 35.7} lng={props?.lngToMap || props?.coordinates[0]?.pointY || 51.4}
          zoom={zoom || props?.zoom}
          id="parsiMap"
          token={"p1a17b4952e44846b5a486861f1f7c9153c49fdb24"}
          style={{"height": "300px", width: '100%'}}
          onClick={(map) => {
            setZoom(map?.target?.transform?.tileZoom)
            props.setLngLat(map)
            props.handlerSearchWithLocation(map.lngLat.lng || props?.lngToMap || 51.4, map.lngLat.lat || props?.latToMap || 35.7)
          }}
          animationMode={'flyTo'}
          animationDuration={3000}
     >
       {
         props?.coordinates?.map((item, index) =>
            <Marker lngLat={[item?.pointY || props?.lngToMap || 51.4, item?.pointX || props?.latToMap || 35.7]}>
              <Announcement/>
            </Marker>
         )
       }
       <ZoomControl/>

     </Map>
  )
}


export default ParsiMap
